import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core'
import { ModalDialogComponent } from 'src/app/shared/modal-dialog/modal-dialog.component'
import {
  TOOLTIP_SAMPLE_ARN,
  TOOLTIP_SHOWCASE_POSITIONS,
  TOOLTIP_SHOWCASE_VARIANTS,
} from '../../mocks/showcase-tooltips-mocks'

/**
 * Every tooltip flavor the app can produce, as the manual check for arrow/bubble
 * alignment. Pure directive usage — no mock plumbing or service patches needed.
 */
@Component({
  selector: 'showcase-tooltips',
  templateUrl: './showcase-tooltips.component.html',
  styleUrls: ['./showcase-tooltips.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ShowcaseTooltipsComponent {
  readonly tooltipVariants = TOOLTIP_SHOWCASE_VARIANTS
  readonly tooltipPositions = TOOLTIP_SHOWCASE_POSITIONS
  readonly tooltipSampleArn = TOOLTIP_SAMPLE_ARN

  @ViewChild('tooltipInDialog') tooltipInDialog: ModalDialogComponent

  // Tooltips inside a p-dialog take PrimeNG's deferred align path (a 100ms timeout
  // before the first measurement), so they need their own host to verify.
  openTooltipInDialog(): void {
    this.tooltipInDialog?.open()
  }
}
